import { useLocaleState, useRecordContext } from "react-admin";

import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";
const ClosingCreated = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Date Executed"
            value={record.created_at}
            format="date"
            prefix="EST"
          />
          <LabelField title="Executed By" value={record.sOper} />
          <LabelField
            title="Execution Status"
            value={
              record.sOption === "Pre-Approved"
                ? "Pre-Approval Offer Sent"
                : record.sOption === "Declined"
                ? "Declined Docs Sent"
                : record.sOption === "Countered"
                ? "Countered Docs Sent"
                : "Closing Docs Sent"
            }
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record.sComment && record.sComment.length > 0 ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
              titlePosition="top"
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ClosingCreated;
